import { Schema } from "effect";
export const FirebaseToken = Schema.Struct({
    token: Schema.String,
});
